import {
    PP_TOKEN_GENERATE_START,
    PP_TOKEN_GENERATE_SUCCUSS,
    PP_TOKEN_GENERATE_FAIL,
    CLEAR_TOKEN_ERROR
} from "../store/types"



const initialState = {
    PPtoken: null,
    loading: false,
    PPTokenError: {
        flag: false,
        error: null
    },
};

export const tokenReducer = (state = initialState, action) => {
    switch (action.type) {
        case PP_TOKEN_GENERATE_START:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case PP_TOKEN_GENERATE_SUCCUSS:
            return {
                ...state,
                loading: false,
                token: action.payload,
                error: null,
            };
        case PP_TOKEN_GENERATE_FAIL:
            return {
                ...state,
                loading: false,
                PPTokenError: {
                    flag: true,
                    error: action.payload
                }
            };
        case CLEAR_TOKEN_ERROR:
            return {
                ...state,
                PPTokenError: {
                    flag: false,
                    error: null
                },
            };
        default:
            return state;
    }
};

export default tokenReducer;